/*Public JS - Version 1*/
import * as dataGetter from "./modules/wp-wpp-data-getter.js";
import { isValid, phoneMask } from "./modules/wp-wpp-data-validation.js"

(function () {
    let wppPopUp = document.querySelector('.floating-wpp-modal');
    let wppButtons = document.querySelectorAll('.wp-wpp-open-button');
    let wppForm = document.querySelector('.wp-wpp-form form');
    let wppRequiredFields = document.querySelectorAll('.wp-wpp-form form [aria-required="true"]');
    let wppTelFields = document.querySelectorAll('.wp-wpp-form form input[type="tel"]');

    function addOpenModalListeners(button) {
        button.addEventListener('click', function(event) {
            wppPopUp.classList.toggle('active');
            event.preventDefault();
        });
    }

    function sendForm(event) {
        event.preventDefault();

        if (isValid(wppRequiredFields)) {
            openWhatsapp();
        }
    }

    function openWhatsapp() {
        wpWpp.contactMessage = replacePlaceholders(wpWpp.contactMessage);
        window.open('https://api.whatsapp.com/send?phone=' + wpWpp.phone + '&text=' + wpWpp.contactMessage, wpWpp.openInAnotherTab ? '_blank' : '_self');
    }

    function replacePlaceholders(message) {
        message = message.replace('{url}', window.location.href);

        wppRequiredFields.forEach(function (field) {
            message = message.replace('{' + field.name + '}', field.value);
        })

        return message;
    }

    if (wppButtons.length > 0) {
        wppButtons.forEach(addOpenModalListeners);
    }

    if (wppTelFields.length > 0) {
        wppTelFields.forEach(phoneMask);
    }

    if (wppForm) {
        wppForm.addEventListener('submit', sendForm);
    }
})();